import "./tollList.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import TollTable from "../tolltable/TollTable";

const TollList = () => {
  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <TollTable />
      </div>
    </div>
  );
};

export default TollList;
